import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["showScore", "showGraph", "score", "change", "title", "emptyMessage", "to", "chartData", "chartLabels", "selectedValue", "chartHeight", "options", "getTooltipReadout", "showAllLabels", "chartLabelClicks"];
import React from 'react';
import { Link } from 'react-router-dom';
import useUniqueId from 'hooks/useUniqueId';
import getLocalisedDate from 'utils/dates/getLocalisedDate';
import Card from 'components/Card';
import Text from 'components/Text';
import Icon from 'components/Icon';
import Heading from 'components/Heading';
import TextLink from 'components/TextLink';
import Flex, { Box } from 'components/Flex';
import TrendIndicator from 'components/TrendIndicator';
import { ChartWithPoints } from 'components/Charts';
function GraphCard(_ref) {
  var _ref$showScore = _ref.showScore,
    showScore = _ref$showScore === void 0 ? true : _ref$showScore,
    _ref$showGraph = _ref.showGraph,
    showGraph = _ref$showGraph === void 0 ? true : _ref$showGraph,
    score = _ref.score,
    change = _ref.change,
    title = _ref.title,
    emptyMessage = _ref.emptyMessage,
    to = _ref.to,
    _ref$chartData = _ref.chartData,
    chartData = _ref$chartData === void 0 ? [] : _ref$chartData,
    _ref$chartLabels = _ref.chartLabels,
    chartLabels = _ref$chartLabels === void 0 ? [] : _ref$chartLabels,
    selectedValue = _ref.selectedValue,
    chartHeight = _ref.chartHeight,
    options = _ref.options,
    getTooltipReadout = _ref.getTooltipReadout,
    showAllLabels = _ref.showAllLabels,
    chartLabelClicks = _ref.chartLabelClicks,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var titleId = useUniqueId();
  var selected = selectedValue ? getLocalisedDate({
    date: selectedValue,
    options: {
      month: 'short',
      day: 'numeric'
    }
  }) : null;
  var hasScore = score !== undefined && score !== null;
  var minimumDataPoints = 1; // Minimum data points required to display the chart

  return /*#__PURE__*/React.createElement(Card, {
    role: "region",
    "aria-labelledby": titleId
  }, /*#__PURE__*/React.createElement(Flex, {
    column: true,
    align: "stretch",
    height: "100%",
    gap: "xs"
  }, /*#__PURE__*/React.createElement(Box, {
    py: "s",
    px: "m"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    id: titleId
  }, to ? /*#__PURE__*/React.createElement(TextLink, {
    stealthy: true,
    as: Link,
    to: to
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    gap: "xs",
    alignItems: "top"
  }, title, /*#__PURE__*/React.createElement(Icon, {
    color: "links",
    name: "arrow-right",
    size: "unscaled",
    ml: "xs"
  }))) : title), /*#__PURE__*/React.createElement(Flex, {
    align: "top",
    mt: "xs",
    gap: "xxs"
  }, showScore && (hasScore ? /*#__PURE__*/React.createElement(Text, {
    bold: true,
    fontSize: "xxl"
  }, score, /*#__PURE__*/React.createElement(Text, {
    fontSize: "xxs"
  }, "%")) : /*#__PURE__*/React.createElement(Text, {
    bold: true,
    fontSize: "xxl",
    dimmed: true
  }, "-")), !!change && /*#__PURE__*/React.createElement(TrendIndicator, {
    size: "s",
    value: change
  }))), showGraph && /*#__PURE__*/React.createElement(Box, _extends({
    mt: "auto",
    px: "s"
    // Ensure all the labels are visible on x-axis
    ,
    mr: "xs"
  }, otherProps), /*#__PURE__*/React.createElement(ChartWithPoints, {
    emptyMessage: emptyMessage,
    data: chartData,
    minimumDataPoints: minimumDataPoints,
    labels: chartLabels,
    labelClicks: chartLabelClicks,
    selectedValue: selected,
    getTooltipReadout: getTooltipReadout,
    chartHeight: chartHeight,
    options: options,
    showAllLabels: showAllLabels
  }))));
}
export default GraphCard;